import axios, { officialId, $encrypt, testR, $asyncPost } from "./common.js";

/* axios.defaults.baseURL = "https://test-api.hakspay.cn/";
axios.defaults.headers.post["Content-Type"] = "application/json"; */
import { Message } from "element-ui";

/**
 * 获取二维码的地址
 * v3/wxHelper/common/PermissionUrl
 * @returns
 */
export const PermissionUrl = function () {
  return axios.get("v3/wxHelper/common/PermissionUrl?appid=" + officialId);
};

//已经取消改接口 获取二维码图片
///common/v2/GetQrCode
/* export const GetQrCodeUrl = function(url) {
  return axios({
    url: `common/v2/GetQrCode?`,
    method: "get",
    params: {
      text: url
    }
  });
}; */

//获取用户登录的临时code
//v3/wxHelper/common/GetUserCode
export const GetUserCode = function (token) {
  return axios.get(`v3/wxHelper/common/GetUserCode?access_token=${token}`);
};

/**
 * 获取用户信息
 * @returns
 */
export const accountQuery = function () {
  return $asyncPost(`v3/Membership/Account/query`, {});
}
//通过临时code 获取用户信息
//https://test-api.hakspay.cn/v2/ePlatform/Service/wxChannel/UserCodeToUnionID
export const UserCodeToUnionID = function (code) {
  // console.log("",code);
  return axios.get(
    `v3/wxHelper/common/UserCodeToAccessToken?appid=${officialId}&code=${code}&code_type=offiaccount`
  );
};

//使用令牌获取用户信息
//https://test-api.hakspay.cn/v2/ePlatform/Service/wxChannel/UserTokenToUserInfo
export const UserTokenToUserInfo = function (access_token, open_id) {
  return axios({
    url: `v3/wxHelper/common/UserTokenToUserInfo?`,
    method: "get",
    params: {
      access_token,
      open_id
    }
  });
};

//服务商登录
//https://test-api.hakspay.cn/v2/ePlatform/Service/ServiceProvider/login
export const ServiceProviderLogin = function (data) {
  return axios.post("v3/ServiceProvider/common/login", data).catch(err => {
    Message.error(err);
  });
};

//https://test-api.hakspay.cn/v2/ePlatform/Service/Membership/Account/register
/**
 * 用户、会员注册
 * Membership/v2/Account/register
 * @param {*} data
 * @returns
 */
export const accountRegister = function (data) {
  return axios.post("Membership/v2/Account/register", data).catch(err => {
    Message.error(err);
  });
};

/**发送短信
 * @param {Object} mobile_no
 */
export const sendMsg = function (mobile_no) {
  return axios.get("common/v2/sms/verifycode?mobile_no=" + mobile_no);
};

/**用户登录
 * Membership/v2/Account/login
 * @param {*} data
 * @returns
 */
export const accountLogin = async function (data) {
  try {
    return await axios.post("Membership/v2/Account/login", data);
  } catch (err) {
    Message.error(err);
  }
};

/**给用户授权的服务商列表
 * v3/ServiceProvider/permission/account/list
 * @returns
 */
export const getlistServiceProvider = async function () {
  try {
    return await axios.get(
      "v3/ServiceProvider/permission/account/list"
    );
  } catch (err) {
    Message.error(err);
  }
};

//TODO: 接口报错 系统异常:对象名 'user_scope' 无效。
/**获取用户可以管理的店铺
 * v3/merchant/permission/account/listMerchant
 */
export const getListMerchant = function () {
  return axios
    .post("v3/merchant/permission/account/listMerchant", {
      access_token: localStorage.getItem("access_token")
    })
    .catch(err => {
      Message.error(err);
    });
};

/**
 * 公众号APPID生成带参数的二维码
 * https://test-api.hakspay.cn/v2/ePlatform/Service/wxChannel/GenerateParaetermQr
 * @returns
 */
export const GenerateParaetermQr = function () {
  return axios({
    url: `v2/ePlatform/Service/wxChannel/GenerateParaetermQr`,
    method: "get",
    params: {
      appid: officialId,
      action_name: "QR_SCENE",
      expire_seconds: ""
    }
  });
};

/**
 * 店铺登录接口
 * @param {Object} data
 * @returns
 */
export const merchantLogin = function (data) {
  return axios.post("v3/merchant/common/login", data).catch(err => {
    Message.error(err);
  });
};

//v3/wxHelper/common/GenerateAccessTokenUrl
/**
 * 获取微信web网页授权登录CODE
 * method get
 * @returns {Promise<Object>} {
 *  code: "f1af1bde3b3e4d09a150b32b1c963c57";
 *  expire_seconds: 300;/
 *  ticket: "gQHb7zwAAAAAAAAAAS5odHRwOi8vd2VpeGluLnFxLmNvbS9xLzAyZ2Vxa3dOVm5mdkYxVnNUNk5EY0IAAgQwtsZnAwQsAQAA";
 *  url: "http://weixin.qq.com/q/02geqkwNVnfvF1VsT6NDcB";
 * }
 *
 */
export const generateAccessTokenUrl = function () {
  return axios.get(
    `v3/wxhelper/login/GetLoginQr?appid=wx59275b1f7f83e45f`
  )
  /*  const url = `v3/wxHelper/common/GenerateAccessTokenUrl?appid=${officialId}`;
  return axios({
    url: "v3/wxHelper/common/GenerateAccessTokenUrl?appid=wx59275b1f7f83e45f",
    method: "get"
  });*/
};

/**
 *
 */
/* export const wxTicketUrl = function(ticket){
  return axios.get(`https://mp.weixin.qq.com/cgi-bin/showqrcode?ticket=${ticket}`)
} */

/**
 * 获取令牌接口
 */
export const getToken = async function () {
  const gettokentimmer = (new Date()).valueOf();
  return new Promise((resolve, reject) => {
    $encrypt(
      localStorage.getItem("pass_word"),
      "pass_word"
    ).then(pass_word => {
      if (!localStorage.getItem("gettokentimmer") || (localStorage.getItem("gettokentimmer") && (Math.abs((new Date(Number(localStorage.getItem("gettokentimmer")))).valueOf() - gettokentimmer)) >=
        6000)) { //判断如果本地有 gettokentimmer 并且于现在时间相差大于一分钟才可以获取
        localStorage.setItem("gettokentimmer", gettokentimmer);
        switch (localStorage.getItem("token_type")) {
          case "account":
            if (
              localStorage.getItem("gettoken_type") &&
              localStorage.getItem("gettoken_type") === "scan"
            ) {
              window.showQrCode(true).then(a => { //
                console.log("window.showQrCode");
                if (a === true) resolve(true);
                else resolve(false);
              }).catch(e => {
                throw e
              })
              resolve(false);
              //扫码登录
            } else if (!localStorage.getItem("gettoken_type")) {
              var obj = {
                account_type: "account_id",
                account_id: localStorage.getItem("account_id"),
                pass_word
              };
              accountLogin(obj).then(account_login => {
                if (testR(account_login)) {
                  setToken(
                    account_login.data.resp_data.access_token,
                    account_login.data.resp_data.expire_time
                  );
                  resolve(true);
                }
              }).catch(e => {
                throw e
              })
              resolve(false);
            }
            break;
          case "service":
            var objs = {
              service_no: localStorage.getItem("service_no"),
              pass_word
            }
            ServiceProviderLogin(objs).then(serverlogin_res => {
              if (testR(serverlogin_res)) {
                setToken(
                  serverlogin_res.data.resp_data.access_token,
                  serverlogin_res.data.resp_data.expire_time
                );
                resolve(true);
              } else resolve(false);
            })
            break;
          case "merchant":
            var obj1 = {
              merchant_id: localStorage.getItem("merchant_id"),
              pass_word
            };
            merchantLogin(obj1).then(merchantlogin_res => {
              console.log("merchantlogin_res店铺登录----", merchantlogin_res);
              if (testR(merchantlogin_res)) {
                setToken(
                  merchantlogin_res.data.resp_data.access_token,
                  merchantlogin_res.data.resp_data.expire_time
                );
                resolve(true);
              } else resolve(false);
            }).catch(e => {
              resolve(false);
            })
            break;
        }
      } else { //一分钟之内已经有登录的请求
        setTimeout(() => {
          resolve(true);
        }, 2000)
      }
    })
  })
};

const setToken = function (access_token, expire_time) {
  localStorage.setItem("access_token", access_token);
  localStorage.setItem("expire_time", expire_time);
};
